import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { API } from "../lib/site";

export const Field = ({ label, name, testid, as = "input", children, className = "", ...rest }) => {
  const Tag = as;
  return (
    <label className={`block ${className}`}>
      <span className="field-label">{label}{rest.required && <span className="text-[var(--glow)]"> *</span>}</span>
      <Tag name={name} className="field" data-testid={testid} {...rest}>{children}</Tag>
    </label>
  );
};

// Shared submit state + POST for every form.
export const useSubmit = (path, successMsg) => {
  const [state, setState] = useState("idle");
  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!API) { toast.error("Forms are offline right now — please email us instead."); return; }
    setState("loading");
    try {
      await axios.post(`${API}${path}`, Object.fromEntries(new FormData(form)));
      setState("done");
      form.reset();
      toast.success(successMsg);
    } catch (err) {
      setState("idle");
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Please check your details and try again.");
    }
  };
  return { state, onSubmit, reset: () => setState("idle") };
};

export const SubmitButton = ({ state, label, testid }) => (
  <button type="submit" disabled={state === "loading"} data-testid={testid}
    className="btn-gold mt-4 inline-flex w-full items-center justify-center gap-3 rounded-full px-9 py-5 text-[13px] font-semibold uppercase tracking-[0.2em] disabled:opacity-70 sm:w-auto">
    {state === "loading" ? <Loader2 size={16} className="animate-spin" /> : state === "done" ? <Check size={16} /> : null}
    {state === "loading" ? "Sending" : state === "done" ? "Sent — send another?" : label}
    {state === "idle" && <ArrowRight size={16} />}
  </button>
);
